<template>
    <div class="ht-view-container">
        <div ref="htView" class="ht-view"></div>
    </div>
</template>

<script>
import resizeEvent from 'element-resize-event'

/**
 * @Props
 *   type [String] 视图类型 可选值('2d'|'3d')
 *   auto-invalidate [Boolean] 是否开启自动重绘
 * 
 * @Methods
 *   getDataModel 获取当前视图的dataModel
 *   getGraphView 获取当前视图的graphView|graph3dView
 */
export default {
    name: 'HtView',
    props: {
        type: {
            type: String,
            default: '2d',
            required: true,
            validator(val){
                if(val == '2d' || val == '3d'){
                    return true;
                }
                return false;
            }
        },
        // 自动重绘
        autoInvalidate: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            dataModel: undefined,
            graphView: undefined
        }
    },
    mounted(){
        this.dataModel = new ht.DataModel();

        if(this.type == '2d'){
            this.graphView = new ht.graph.GraphView(this.dataModel);
        }else{
            this.graphView = new ht.graph3d.Graph3dView(this.dataModel);
        }

        var view = this.graphView.getView();     
        view.style.width = '100%';
        view.style.height = '100%';
        this.$refs.htView.appendChild(view);

        // 监听组件外层resize事件
        // 此处的resize事件使用'element-resize-event'三方库监听
        resizeEvent(this.$refs.htView, ()=>{
            // 使graphView失效, 重绘场景
            this.autoInvalidate && this.graphView.invalidate();
        });
    },
    beforeDestroy(){
        // 取消resize监听
        resizeEvent.unbind(this.$refs.htView);
    },

    methods: {
        // 获取当前组件的ht.dataModel
        getDataModel(){
            return this.dataModel;
        },
        // 获取当前组件的ht.graphView
        getGraphView(){
            return this.graphView;
        }
    }
}
</script>

<style lang="scss" scoped>
.ht-view-container{
    .ht-view{
        text-align: left;
        width: 100%;
        height: 100%;
        position: relative;
    }
}
</style>